//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Epk.WebControls.GEpkDashboard.cs						</Name>
//    <Description> Statistiky pro EPK							                </Description>
//    <Author>      Tomáš Hažmuka												</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019							</Copyright>
//    <Created>     2019-10-01													</Created>
//  </FileHeader>

namespace Gordic.Epk.WebControls {

    const { gcontent } = Decorators;

    /**
     * Statistiky pro EPK
     */
    @gcontent
    export class GEpkDashboard extends GContentBase {

        /** parametry v EPK */
        private EpkParams: Gordic.Gin.WebClient.GEpkParamsDto;
        private NazevRef: string;
        private NazevFun: string;
        private DatLoginTxt: string;
        private model: any;
        private VracenoKPrepracovaniVisible: boolean;
        private VyrizenoVisible: boolean;
        private AllowShowOwnRequestsTestMinDbVersion: boolean;

        /** příznak mobilního zobrazení z webconfigu */
        private EpkMobile: "0" | "1";
        /** list posledně použitých dokumentů */
        private LastUsed: any[];

        public onContentReady() {
            this.createInternalActionsForTestEpk();
            this.init();
        }

        private createInternalActionsForTestEpk() {

            var actGenRqInternal = new GAction({
                name: "actGenRqInternal",
                caption: "GenRqInternal",
                run: () => {

                    const idFlash = "GenRqInternalFlashId";
                    this.hideFlash(idFlash);

                    this.call("Generate")
                        .then((state) => {
                            if (state === true) {
                                this.showFlash({
                                    content: "jres:32001069", //RC 32001069 : Internal generation of requests has been successfully completed
                                    state: "info",
                                    id: idFlash
                                });
                            }
                        });
                }
            });

            this.actions.add(actGenRqInternal);

        }

        private init() {

            if (this.globalSettings == null)
                return;

            //#region -- PANEL INFORMACÍ O MODULU --

            var hideModulInfoValue: boolean = this.globalSettings.get("Global.Epk.AppSettings.ModulInfo");
            var hideModulInfo = hideModulInfoValue == null ? false : hideModulInfoValue;

            if (hideModulInfo !== true) {
                this.loadModuleInfo();
            }

            //#endregion

            var List: IGDashboardPanelOptions[] = [];
            var dashboardZones = 1;

            // thazmuka 25.11.2021 - zobrazovat i při povoleném supervisoru DB parametru T16062
            if (this.EpkParams.gin_rad_epkpri! > 0 && (this.EpkParams.ssl_epk_vyrid! === 1 || this.EpkParams.epk_prehl_org! > 0)) {
                List = this.showKpiCount();

                var DisableOverviewLastUsed: boolean = this.globalSettings.get("Global.Epk.AppSettings.DisableOverviewLastUsed");
                if (DisableOverviewLastUsed !== true) {
                    dashboardZones = 2;
                    List.push(this.showLastUsed());
                }
            }

            this.createDashboard(List, dashboardZones);
            this.findFields()
                .gfield("model", "apply", this.model)

        }

        private showLastUsed() {
            return new WebControls.EpkLastUsed().getItem(this.LastUsed, this);
        }

        private showKpiCount() {

            if (this.EpkParams.epk_zobrvrac === true)
                this.VracenoKPrepracovaniVisible = true;

            return new WebControls.EpkScoreboard(this.EpkMobile).getItem(this, this.model.Counts, {
                vraceno: this.VracenoKPrepracovaniVisible,
                vyrizeno: this.VyrizenoVisible,
                vlastni: this.AllowShowOwnRequestsTestMinDbVersion
            }, {
                epk_prehl_org: this.EpkParams.epk_prehl_org!
            });
        }

        private createDashboard(data: IGDashboardPanelOptions[], zones: number) {
            $("<div>")
                .appendTo(this.element)
                .gdashboardpanel({
                    id: "uvodniPoctyPanel",
                    defaultSelected: false,
                    data: data,
                    layout: "horizontal",
                    sortable: true,
                    zones: zones
            });
        }

        private loadModuleInfo() {

            var i = 0;
            var secondaryText = this.NazevRef + " | " + this.NazevFun + " | " + "jres:32000465" + ": " + this.DatLoginTxt; //RC 32000465 : Poslední přihlášení

            var data: any[] = [];
            data.push(new GObservableObject({
                name: "kpiLastUsed" + "_" + i,
                image: "<img class='g-app-launcher__item' style='width:48px;height:48px;' alt='EPK' src='gin/gz.ashx?r=app&amp;f=GWAEPK05.svg'>",
                primaryText: "jres:32000331", //RC 32000331 : Elektronická podpisová kniha
                secondaryText: secondaryText,
            }));

            const dataView = new Gordic.Data.View(data, { key: "name" });

            var moduleInfoItems = new Gordic.Data.View([{
                id: "modulInfo",
                title: "jres:32000754", //RC 32000754 : Modul
                zone: 1,
                mode: "vertical",
                itemTemplate: Gordic.Prefabs.Panels.kpiImageTwoRowsTextTemplate().itemTemplate,
                defaultSelected: false,
                data: dataView,
                menuParams: [
                    {
                        icon: "fa-retweet",
                        action: new GAction({
                            name: "actModulRefresh",
                            captionVisible: GAction.captionVisibility.never,
                            caption: "jres:32001068", //RC 32001068 : Aktualizovat
                            visible: true,
                            run: (ev, ctx) => {
                                this.load();
                            }
                        })
                    }
                ]
            }], { key: ["id"] });

            var gdashboard = $("<div>")
                .appendTo(this.element);

            gdashboard
                .gdashboardpanel({
                    id: "modulInfoPanel",
                    defaultSelected: false,
                    data: moduleInfoItems,
                    layout: "horizontal",
                    sortable: true,
                });
        }

       

    }

}